export const velarisFeature = {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1035e490-4d04-41a5-ba97-aeb9b32614fd.jpg',
  alt: 'A candlelit black-tie dinner on a cliffside terrace above the Riviera at night, a lit yacht on the water below',
  line: 'Dive in, catch on, break out.',
  details: [
    { label: 'Where', value: 'The Riviera' },
    { label: 'When', value: 'Three nights, July' },
    { label: 'Guests', value: 'By invitation' },
  ],
  href: '/venturist',
};

// Other chapters of the series
export const seriesEvents = [
  {
    name: 'Nocturne',
    place: 'The Alps · January',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7e650f15-a01a-4563-a153-5a4691c0d4c4.jpg',
    alt: 'A candlelit dinner in a glass pavilion high in the snowy Alps at night',
    href: '/membership',
  },
  {
    name: 'Solenne',
    place: 'Arabian Desert · March',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/38677946-5839-452c-a4d0-26e67ee9e5a4.jpg',
    alt: 'A lantern-lit private gathering among desert dunes at dusk',
    href: '/membership',
  },
  {
    name: 'Isola',
    place: 'Mediterranean · September',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4640d629-4e19-424c-bcc8-8f6985de62a7.jpg',
    alt: 'A yacht party under string lights in a secluded island cove at midnight',
    href: '/membership',
  },
  {
    name: 'Aurelle',
    place: 'Kyoto · November',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/9f656ffb-087b-4143-aa8f-f7b516d2f9ef.jpg',
    alt: 'A lantern-lit private dinner on the veranda of a Kyoto temple garden among autumn maples at night',
    href: '/membership',
  },
] as const;
